import React, { useEffect, useState } from 'react';
import { AlertTriangle, Clock } from 'lucide-react';

const InactivityWarning = ({ isOpen, onStayLoggedIn, onLogout }) => {
  const [countdown, setCountdown] = useState(30);

  useEffect(() => {
    if (!isOpen) {
      setCountdown(30);
      return;
    }

    const interval = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-[9999] animate-fade-in">
      <div className="bg-white rounded-2xl p-8 max-w-md w-full mx-4 shadow-2xl animate-scale-in">
        <div className="flex items-center gap-4 mb-6">
          <div className="p-3 bg-amber-100 rounded-full">
            <AlertTriangle className="w-8 h-8 text-amber-600" />
          </div>
          <div>
            <h2 className="text-2xl font-bold text-gray-800">Session Timeout</h2>
            <p className="text-sm text-gray-600">Due to inactivity</p>
          </div>
        </div>

        <div className="mb-6">
          <div className="flex items-center gap-3 mb-4">
            <Clock className="w-5 h-5 text-red-500" />
            <p className="text-gray-700">
              You will be logged out in <span className="font-bold text-red-600 text-xl">{countdown}</span> seconds
            </p>
          </div>
          <p className="text-sm text-gray-600">
            Click "Stay Logged In" to continue your session, or you'll be redirected to the rate display page.
          </p>
        </div>

        <div className="flex gap-3">
          <button
            onClick={onLogout}
            className="flex-1 px-6 py-3 bg-gray-200 text-gray-700 rounded-xl hover:bg-gray-300 transition-colors font-semibold"
          >
            Logout Now
          </button>
          <button
            onClick={onStayLoggedIn}
            className="flex-1 px-6 py-3 bg-gradient-to-r from-amber-500 to-orange-500 text-white rounded-xl hover:shadow-lg transition-all font-semibold"
          >
            Stay Logged In
          </button>
        </div>

        <div className="mt-4 text-xs text-center text-gray-500">
          Auto-logout activates after 5 minutes of inactivity
        </div>
      </div>
    </div>
  );
};

export default InactivityWarning;
